import { render, staticRenderFns } from "./ApprovalDocuments.vue?vue&type=template&id=dae9016e&scoped=true"
import script from "./ApprovalDocuments.vue?vue&type=script&lang=js"
export * from "./ApprovalDocuments.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDocuments.vue?vue&type=style&index=0&id=dae9016e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae9016e",
  null
  
)

export default component.exports